<template>
  <div class="hero admin-page">
    <div class="container is-fluid">
      <router-link :to="{name: 'Admin'}" class="button is-info">Quay Trở Lại Trang Admin</router-link> <b-button type="is-info" @click="openPasswordModal" :class="'button-update'">Đổi mật khẩu</b-button>
      <div class="section">
        <user-list :username="username"></user-list>
      </div>
      <b-modal :active.sync="isOpenUpdatePassModal">
        <div class="content-layout content-layout--passcode">
          <header class="modal-card-head"><p class="modal-card-title">Thay đổi mật khẩu</p><button aria-label="close" class="delete" @click="isOpenUpdatePassModal=false"></button></header>
          <form @submit.prevent="validatePassword">
          <div class="content-layout__inner">
            <div class="form-user">
              <b-field
                :type="{'is-danger': errors.has('password')}"
                :message="errors.first('password')"
                custom-class="has-text-weight-normal"
              >
                <template slot="label">
                  Mật khẩu <span class="has-text-danger">*</span>
                </template>
                <b-input
                  v-model="password"
                  type="password"
                  name="password"
                  v-validate="{required: true, regex: /\w/, min: 8}"
                  size="is-medium"
                  data-vv-as="Mật khẩu"
                  ref="passwordAdmin"
                ></b-input>
              </b-field>
              <b-field
                :type="{'is-danger': errors.has('confirm-password')}"
                :message="errors.first('confirm-password')"
                custom-class="has-text-weight-normal"
              >
                <template slot="label">
                  Xác nhận mật khẩu <span class="has-text-danger">*</span>
                </template>
                <b-input
                  v-model="confirmPassword"
                  v-validate="{ required: true, is: password }"
                  type="password"
                  name="confirm-password"
                  size="is-medium"
                  data-vv-as="Xác nhận mật khẩu"
                ></b-input>
              </b-field>
            </div>
          </div>
          <div class="modal-bottom-group field is-grouped is-grouped-centered">
            <div class="control">
              <b-button @click="isOpenUpdatePassModal=false">Đóng</b-button>
            </div>
            <div class="control">
              <b-button type="is-info" native-type="submit">Thay đổi</b-button>
            </div>
          </div>
          </form>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"

export default {
  data() {
    return {
      username: this.$route.params.username,
      isOpenUpdatePassModal: false,
      password: '',
      confirmPassword: '',
    };
  },
  components: {
    UserList: () => import('./UserList')
  },
  methods: {
    ...mapActions('hostAccount', ['updatePWAccount']),
    validatePassword() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updatePassWord();
        }
      });
    },
    updatePassWord() {
      const password = this.password;
      const user = {user: { username: this.username, password }};
      this.updatePWAccount(user).then((result) => {
        let message = "Thay đổi mật khẩu thành công!";
        if(result.data.status) {
          this.isOpenUpdatePassModal = false;
          this.$toast.open({
            message,
            type: "is-info"
          });
        }
      });
    },
    openPasswordModal() {
      this.isOpenUpdatePassModal = true
      this.$nextTick(() => {
        this.$refs.passwordAdmin.$el.querySelector('input').focus()
      })
    }
  }
};
</script>

<style scoped lang="scss">
  .button-update {
    margin-left: 20px;
  }
  .container {
    margin: 0;
  }
</style>